// EditEventModal.jsx
import React, { useState, useEffect } from 'react';
import DatePicker from 'react-datepicker';
import "react-datepicker/dist/react-datepicker.css";
import { Timestamp } from 'firebase/firestore';
import './Modal.css';

const EditEventModal = ({ eventToEdit, isOpen, onClose, onSave, groups }) => {
    const [title, setTitle] = useState('');
    const [start, setStart] = useState(new Date());
    const [end, setEnd] = useState(new Date());
    const [selectedGroup, setSelectedGroup] = useState('');
  
    useEffect(() => {
        if (eventToEdit) {
            setTitle(eventToEdit.title);
            // Only call toDate() if start and end are indeed Timestamps
            setStart(eventToEdit.start instanceof Timestamp ? eventToEdit.start.toDate() : eventToEdit.start);
            setEnd(eventToEdit.end instanceof Timestamp ? eventToEdit.end.toDate() : eventToEdit.end);
            setSelectedGroup(eventToEdit.groupId); // assuming event has a groupId property
        }
    }, [eventToEdit]);
    
  
    if (!isOpen) {
      return null;
    }

  const handleSave = (e) => {
    e.preventDefault(); // Prevent form submission

    const groupColor = groups.find(group => group.id === selectedGroup)?.color;

    onSave({
      ...eventToEdit,
      title,
      start: new Date(start),
      end: new Date(end),
      groupId: selectedGroup,
      color: groupColor,
    });
    onClose();
  };

  return (
    <div className="modal">
      <div className="modal-content">
        <span className="close" onClick={onClose}>&times;</span>
        <form onSubmit={handleSave}>
        <label htmlFor="eventTitle">Event Title:</label>
        <br></br>
          <input
            type="text"
            value={title}
            onChange={(e) => setTitle(e.target.value)}
            placeholder="Event Title"
            required
          />
          <div className="datetime-picker-container">
            <label htmlFor="start-time">Start Time:</label>
            <DatePicker
              id="start-time"
              selected={start}
              onChange={date => setStart(date)}
              showTimeSelect
              timeIntervals={30}
              timeFormat="hh:mm aa"
              dateFormat="MMMM d, yyyy h:mm aa"
              timeCaption="Time"
              className="date-picker"
            />
          </div>
          <div className="datetime-picker-container">
            <label htmlFor="end-time">End Time:</label>
            <DatePicker
              id="end-time"
              selected={end}
              onChange={date => setEnd(date)}
              showTimeSelect
              timeIntervals={30}
              timeFormat="hh:mm aa"
              dateFormat="MMMM d, yyyy h:mm aa"
              timeCaption="Time"
              className="date-picker"
            />
          </div>
          <select
            value={selectedGroup}
            onChange={(e) => setSelectedGroup(e.target.value)}
            required
          >
            <option value="">Select Group</option>
            {groups.map(group => (
              <option key={group.id} value={group.id}>{group.name}</option>
            ))}
          </select>
          <button type="submit">Save</button>
        </form>
      </div>
    </div>
  );
};

export default EditEventModal;